import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/css';
import style from '../../css/Home/cruisCompanyItem.module.css'
import 'swiper/css/navigation';
import InfoButton from './infoButton';
import { ReactComponent as Arrow } from '../../assets/icons/svg/arrowLeft.svg'

// 그룹화를 위한 유틸 (모바일: 4개씩)
const chunkBy = (arr, size) => {
  const chunks = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
};

// 크루즈 선사 목록을 반응형으로 스와이프/그리드 전환하며 렌더링한다.
function CruiseCompanyItem({ item }) {
  const navigate = useNavigate();
  const [isSwiper, setIsSwiper] = useState(window.innerWidth <= 651);
  const swiperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isBeginning, setIsBeginning] = useState(true);
  const [isEnd, setIsEnd] = useState(false);

  // 모바일 페이지(슬라이드) 계산: 4개씩 묶음
  const isMobile = isSwiper;
  const mobilePages = isMobile ? chunkBy(item, 4) : [];
  const totalSlides = isMobile ? mobilePages.length : item.length;

  useEffect(() => {
    const handleResize = () => {
      setIsSwiper(window.innerWidth <= 651);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (!isSwiper) return;
    // swiper 인스턴스가 준비되면 현재 인덱스 기준으로 버튼 상태를 재계산
    if (swiperRef.current) {
      const sw = swiperRef.current;
      const idx = sw.activeIndex || 0;
      const total = mobilePages.length;
      setActiveIndex(idx);
      setIsBeginning(idx <= 0);
      setIsEnd(total <= 1 ? true : idx >= total - 1);
    } else {
      // 인스턴스가 아직 없을 때도 총 슬라이드 수에 맞춰 초기화
      const total = mobilePages.length;
      setActiveIndex(0);
      setIsBeginning(true);
      setIsEnd(total <= 1);
    }
  }, [isSwiper, mobilePages.length]);

  const handlePrev = () => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  };

  const handleNext = () => {
    if (swiperRef.current) swiperRef.current.slideNext();
  };

  const updateNavButtons = (swiper) => {
    const idx = swiper?.activeIndex ?? 0;
    setActiveIndex(idx);
    const total = isSwiper ? (mobilePages.length || 0) : (item?.length || 0);
    setIsBeginning(idx <= 0);
    setIsEnd(total <= 1 ? true : idx >= total - 1);
  };

  return isSwiper ? (
    <div className={style['cruise-list']}>
      <Swiper
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
          updateNavButtons(swiper);
          if (swiper && typeof swiper.updateAutoHeight === 'function') {
            swiper.updateAutoHeight(0);
          }
        }}
        onSlideChange={(swiper) => {
          updateNavButtons(swiper);
          if (swiper && typeof swiper.updateAutoHeight === 'function') {
            swiper.updateAutoHeight(300);
          }
        }}
        spaceBetween={10}
        slidesPerView={1}
        autoHeight={true}
      >
        {mobilePages.map((group, pageIndex) => (
          <SwiperSlide
            key={pageIndex}
            className={group.length <= 2 ? style['few-slide'] : ''}
          >
            <div className={`${style['slide-grid']} ${style['slide-anim']}`}>
              {group.map((it, idx) => (
                <button key={`${it.id ?? idx}`}
                        className={`${style['cruise-item']}`}
                        onClick={() => navigate(`/tabList?type=line&tabId=tab_${it.id}`)}>
                  <img src={it.icon} alt='' />
                  <div>{it.name}</div>
                  <InfoButton placement="top" offsetY={8}>
                    <img src={it.fullIcon} alt='아이콘'/>
                    <p style={{margin:'24px 0 8px', fontWeight:'500', fontSize:'14px', lineHeight:'160%'}}>{it.name}</p>
                    <p style={{textAlign:'left', fontWeight:'400', fontSize:'14px', lineHeight:'160%'}}>{it.desc}</p>
                  </InfoButton>
                </button>
              ))}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className={style['swiper-navigation-wrapper']}>
        <div className={style['swiper-navigation']}>
          <button onClick={handlePrev} disabled={isBeginning}><Arrow /></button>
          <span>
            {/* {activeIndex + 1} / {item.length} */}
            {activeIndex + 1}
          </span>
          <button onClick={handleNext} disabled={isEnd}><Arrow style={{rotate:'180deg'}}/></button>
        </div>
      </div>
    </div>
  ) : (
    <div className={style['cruise-list']}>
      {item.map((item, index) => (
        <button key={index} className={style['cruise-item']} onClick={() => navigate(`/tabList?type=line&tabId=tab_${item.id}`)}>
          <img src={item.icon} alt='아이콘' />
          <div>{item.name}</div>
          <InfoButton placement="top" offsetY={80}>
            <img src={item.fullIcon} alt='아이콘'/>
            <img src={item.img} style={{borderRadius:'4px',width:'374px', height:'254px', margin:'24px 0 20px'}}/>
            <p style={{marginBottom:'8px', fontWeight:'500', fontSize:'14px', lineHeight:'160%'}}>{item.name}</p>
            <p style={{textAlign:'left', fontWeight:'400', fontSize:'14px', lineHeight:'160%'}}>{item.desc}</p>
          </InfoButton>
        </button>
      ))}
    </div>
  );
}

export default CruiseCompanyItem;
